import i18next from "i18next";

import { LanguageType } from "@/constants/global";

export const getActiveLanguage = (type: LanguageType) => {
  const language = i18next.language;
  
return language === type;
}